var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1568 0.691017C14.4115 0.945707 14.4115 1.35864 14.1568 1.61333L5.46116 10.309C5.20647 10.5637 4.79353 10.5637 4.53884 10.309L0.191017 5.96116C-0.0636724 5.70647 -0.0636724 5.29353 0.191017 5.03884C0.445707 4.78415 0.858641 4.78415 1.11333 5.03884L5 8.92551L13.2345 0.691017C13.4892 0.436328 13.9021 0.436328 14.1568 0.691017Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVSign);
export default __webpack_public_path__ + "static/media/vSign.15efed637c80e00a07139e8e514b0e74.svg";
export { ForwardRef as ReactComponent };